<!--eslint-disable vue/no-mutating-props -->
<template>
  <div>
    <div
      v-if="nhl_info_request.isNhlForm"
      class="nhl-info-request-consent"
    >
      <div
        class="form-group boolean"
      >
        <div
          class="checkbox"
        >
          <label class="small-label">
            <input
              id="nhl_member_club_info_sharing"
              v-model="nhl_info_request.nhl_member_club_opt_in"
              class="boolean"
              type="checkbox"
              name="marketing_email_consent"
            >
            <span class="custom-checkbox" />
            <span>
              Yes, share my info with the NHL so I can receive news and offers from the NHL and <a
                href="https://www.nhl.com/info/nhl-affiliates-member-clubs"
                role="button"
              >Member Clubs</a>
            </span>
          </label>
        </div>
        <div
          class="checkbox"
        >
          <label class="small-label">
            <!-- id="info_request_marketing_email_consent" -->
            <input
              id="nhl_business_partner_info_sharing"
              v-model="nhl_info_request.nhl_business_partner_opt_in"
              class="boolean"
              type="checkbox"
              name="marketing_email_consent"
            >
            <span class="custom-checkbox" />
            <span>
              Yes, I want news and offers about, and to share my information with, NHL <a
                href="https://www.nhl.com/info/nhl-affiliates-member-clubs#business"
                target="_blank"
                role="button"
                aria-label="Click here to learn more about NHL Business Partners (opens in a new tab)"
              >business partners</a>
            </span>
          </label>
        </div>
        <div class="checkbox">
          <label
            class="content-label"
            v-html="$t('form.nhl_privacy_policy')"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {


  props:{
    // eslint-disable-next-line vue/prop-name-casing
    nhl_info_request: {
      default: () => {},
      type: Object
    },
    // eslint-disable-next-line vue/prop-name-casing
    in_eu:{
      default: false,
      type: Boolean
    }
  },
  created(){
    if(this.nhl_info_request.isInsideUS){
      //eslint-disable-next-line vue/no-mutating-props
      this.nhl_info_request.nhl_member_club_opt_in = true
    }
  }
}
</script>
